import { parse as parseUserAgent } from "express-useragent";
import { createSelector } from "reselect";

const getRawUserAgent = (state) => state.device.rawUserAgent;

const getUserAgent = createSelector([getRawUserAgent], (rawUserAgent) =>
  parseUserAgent(rawUserAgent),
);

export default getUserAgent;
